import React, { useState } from 'react'
import { Tab } from '../../../../../Components/LazyComponents'
import { TabPanel } from '../../../../../Components/Tab/TabPanel'
import { PLAYER_STATS_TABS } from '../../../../../Constants/player'
import { TabHeaderStyle } from '../../../../../Components/Tab/styles'
import { GameLogs } from '../GameLogs'
import { SeasonStatsTable } from '../allSeasonsStats/SeasonStatsTable'
import { CareerStats } from '../career/CareerStats'
import { colors } from '../../../../../Components/consts'
import { TabsContainer } from './styles'

const a11yProps = (index: number) => {
  return {
    id: `stats-tab-${index}`,
    'aria-controls': `stats-tabpanel-${index}`,
  }
}

type TabValue = (typeof PLAYER_STATS_TABS)[number]['value']

export const StatsTabs: React.FC = () => {
  const [value, setValue] = useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    // TODO: Add analytics event for tab change as per coding-style rule

    setValue(newValue)
  }

  const getTabComponent = (tabValue: TabValue): React.ReactNode => {
    const componentMap: Record<TabValue, React.ReactNode> = {
      gameStats: <GameLogs />,
      allSeasons: <SeasonStatsTable />,
      career: <CareerStats />,
    }
    return componentMap[tabValue]
  }

  return (
    <TabsContainer>
      <TabHeaderStyle
        tabColor="light"
        value={value}
        onChange={handleChange}
        aria-label="player stats tabs"
      >
        {PLAYER_STATS_TABS.map((tab, index) => (
          <Tab key={tab.value} label={tab.label} {...a11yProps(index)} />
        ))}
      </TabHeaderStyle>
      {PLAYER_STATS_TABS.map((tab, index) => (
        <TabPanel key={index} value={value} index={index} border={true} borderColor={colors.offWhite}>
          {getTabComponent(tab.value)}
        </TabPanel>
      ))}
    </TabsContainer>
  )
}

export default StatsTabs
